import { HireActiveStatus } from '@/gql/graphql'
import { $t } from '@/composables/translation'

export type HireStatusOption = { label: string; value: HireActiveStatus }

// WdsSelect ticks by item object, so any link presetting this filter must encode the same shape.
export function hireStatusOption(status: HireActiveStatus): HireStatusOption {
  const key = Object.keys(HireActiveStatus).find(
    (name) => HireActiveStatus[name as keyof typeof HireActiveStatus] === status,
  )

  return { label: $t(key ?? status), value: status }
}
